var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAuthorizeUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.846,
    height: 40.858,
    viewBox: "0 0 40.846 40.858",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6141",
    "data-name": "Group 6141",
    transform: "translate(-6.121 -10.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47442",
    "data-name": "Path 47442",
    d: "M-19428.613,4007.415a9.98,9.98,0,0,1,9.973-9.974,9.979,9.979,0,0,1,9.975,9.974,9.979,9.979,0,0,1-9.975,9.975A9.98,9.98,0,0,1-19428.613,4007.415Zm-19.959,7.142a3.219,3.219,0,0,1-.939-2.287v-2.754c0-2.407,1.455-4.7,4.107-6.506,3.463-2.366,9.057-3.943,15.367-3.943q1.45,0,2.852.112a11.806,11.806,0,0,0-3.332,8.237,11.856,11.856,0,0,0,3.184,8.083h-18.963A3.233,3.233,0,0,1-19448.572,4014.556Zm8.086-27.576a10.448,10.448,0,0,1,10.449-10.449,10.447,10.447,0,0,1,10.445,10.449,10.447,10.447,0,0,1-10.445,10.449A10.448,10.448,0,0,1-19440.486,3986.98Z",
    transform: "translate(19455.633 -3966.416)",
    fill: "#4165f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47421",
    "data-name": "Path 47421",
    d: "M2.269,69.637a1.329,1.329,0,0,0-1.88,0h0a1.329,1.329,0,0,0,0,1.88l2.626,2.626a1.329,1.329,0,0,0,1.88,0l4.727-4.727a1.329,1.329,0,0,0,0-1.88h0a1.329,1.329,0,0,0-1.88,0L4.066,71.212a.156.156,0,0,1-.221,0Z",
    transform: "translate(31.986 -29.841)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthorizeUser);
export default __webpack_public_path__ + "static/media/authorize-user.af239d000d182f354f46e1c4761011f2.svg";
export { ForwardRef as ReactComponent };